import Cookies from 'js-cookie'

export const getStoredRefreshToken = () => Cookies.get('refreshToken')

export const storeRefreshToken = (token) => Cookies.set('refreshToken', token, { secure: true })

export const removeStoredRefreshToken = () => Cookies.remove('refreshToken')
